const API_URL = import.meta.env.VITE_API_URL;

function getApiUrl(endpoint, context = null) {
    if (!context) {
        return API_URL + endpoint;
    }

    let url = API_URL;

    if (context.organisationId) {
        url += context.organisationId + '/';
    }

    return url + endpoint;
}

export function monitorToken() {
    setInterval(async function () {
        console.log("Checking token...");
        await checkToken();
    }, 60000);
}

async function checkToken() {
    const expires = localStorage.getItem('expires');

    // Check if the token is close to expiring
    if (expires) {
        const expiresDate = new Date(expires);
        const currentDate = new Date();
        const difference = expiresDate - currentDate;

        // If the token is within 5 minutes of expiring, refresh it
        if (difference < 300000) {
            const response = await postRequest('user/refresh', {}, null, true, true);

            if (response.ok) {
                const responseJson = await response.json();
                localStorage.setItem('token', responseJson.token);
                localStorage.setItem('expires', responseJson.expires);
            } else {
                localStorage.removeItem('token');
                localStorage.removeItem('expires');
            }
        }
    }
}

export async function getRequest(url, context = null, authenticated = true, skipCheck = false) {
    let headers = {
        'Content-Type': 'application/json'
    };

    if (authenticated) {
        if (!skipCheck) {
            await checkToken();
        }

        const token = localStorage.getItem('token');

        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    return fetch(getApiUrl(url, context), {
        method: 'GET',
        headers: headers
    });
}

export async function postRequest(url, data, context = null, authenticated = true, skipCheck = false) {
    let headers = {
        'Content-Type': 'application/json'
    };

    if (authenticated) {
        if (!skipCheck) {
            await checkToken();
        }

        const token = localStorage.getItem('token');

        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    return fetch(getApiUrl(url, context), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    });
}

export async function putRequest(url, data, context, authenticated = true, skipCheck = false) {
    let headers = {
        'Content-Type': 'application/json'
    };

    if (authenticated) {
        if (!skipCheck) {
            await checkToken();
        }

        const token = localStorage.getItem('token');

        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    return fetch(getApiUrl(url, context), {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(data)
    });
}

export async function deleteRequest(url, data, context = null, authenticated = true, skipCheck = false) {
    let headers = {
        'Content-Type': 'application/json'
    };

    if (authenticated) {
        if (!skipCheck) {
            await checkToken();
        }

        const token = localStorage.getItem('token');

        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    return fetch(getApiUrl(url, context), {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(data)
    });
}

export async function uploadFile(url, file, context = null, authenticated = true, skipCheck = false) {
    let headers = {
        'Content-Type': file.type || 'application/octet-stream' // Ensure it's a binary type
    };

    if (authenticated) {
        if (!skipCheck) {
            await checkToken();
        }

        const token = localStorage.getItem('token');
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    return fetch(getApiUrl(url, context), {
        method: 'POST',
        headers: headers,
        body: file // Send raw binary
    });
}